import PolicyEditor from "./PolicyEditor";

export default function TermsAdmin() {
  return <PolicyEditor kind="terms" />;
}
